var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeCancellationActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 38
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-cancellation-active_svg__a",
    x1: "89.052%",
    x2: "2.642%",
    y1: "16.995%",
    y2: "79.994%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4AFFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DBFCC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#free-cancellation-active_svg__a)",
    d: "M6.522 7l22.172 22.5H1.958l-.936-1.255L1 18.5 2.022 7.929z",
    transform: "translate(.978 .5)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A4A4A",
    fillRule: "nonzero",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.857 7.429h15.714c1.115 0 2 .885 2 2v1.428H21.086c-.515 0-.772.629-.4.972l3.085 3.085c.315.315.772.515 1.2.515h9.6v8.285c0 .486.372.857.858.857a.842.842 0 00.857-.857V9.43a3.707 3.707 0 00-3.715-3.715H16.857a.842.842 0 00-.857.857c0 .486.371.858.857.858zM3.514 30.286h25.829l2.028 2.028a.87.87 0 00.6.257c.2 0 .429-.085.6-.257.343-.343.343-.885 0-1.2L7.43 5.971 1.714.257c-.343-.343-.885-.343-1.2 0-.343.343-.343.886 0 1.2L4.8 5.714H4A3.707 3.707 0 00.286 9.43v17.628a3.243 3.243 0 003.228 3.229zm0-1.715A1.524 1.524 0 012 27.057V15.43h12.514l13.143 13.14H3.514zM4 7.43h2.514l3.429 3.428H2V9.43c0-1.115.886-2 2-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.429,
    cy: 35.143,
    r: 1
  })))));
}
export default SvgFreeCancellationActive;